import React, { useEffect } from 'react';
import { useAuth0 } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
  const { isAuthenticated, isLoading, error, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      if (!isLoading) {
        if (isAuthenticated) {
          // Store Auth0 access token in localStorage for API interceptor
          try {
            const token = await getAccessTokenSilently();
            localStorage.setItem('authToken', token);
          } catch (err) {
            console.error('Failed to get access token:', err);
          }
          navigate('/home');
        } else if (error) {
          console.error('Authentication error:', error);
          navigate('/login');
        }
      }
    };
    handleCallback();
  }, [isAuthenticated, isLoading, error, navigate, getAccessTokenSilently]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div className="loading-spinner"></div>
      <p style={{ marginTop: '1rem', color: '#666' }}>Completing sign in...</p>
    </div>
  );
};

export default Callback;
